import React, { useState } from 'react';
import PreviewBar from '../components/PreviewBar';
import {
  ERROR_INVALID_PREVIEW,
  PREVIEW_ERROR_KEY,
  PREVIEW_HASH_KEY,
  getPreviewHash,
} from '../core/preview';

interface PreviewContextProps {
  previewHash?: string;
  onPreviewException: () => void;
  error: string | null;
  isPreview: boolean;
}

const PreviewContext = React.createContext<PreviewContextProps>({
  previewHash: undefined,
  onPreviewException: () => void 0,
  error: null,
  isPreview: false,
});

export function PreviewContextProvider({ children }) {
  const previewHash = getPreviewHash();
  const [error, setError] = useState(
    window.sessionStorage.getItem(PREVIEW_ERROR_KEY),
  );

  const onPreviewException = () => {
    window.sessionStorage.setItem(PREVIEW_ERROR_KEY, ERROR_INVALID_PREVIEW);
    window.sessionStorage.removeItem(PREVIEW_HASH_KEY);
    setError(ERROR_INVALID_PREVIEW);
  };

  return (
    <PreviewContext.Provider
      value={{
        previewHash: !error ? previewHash : undefined,
        onPreviewException,
        error,
        isPreview: !!previewHash || !!error,
      }}
    >
      <PreviewBar />
      {children}
    </PreviewContext.Provider>
  );
}

export default PreviewContext;
